<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Bulk Schedule Calls</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <form @submit.prevent="save" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Select Profiles *</label>
          <div class="max-h-32 overflow-y-auto border rounded p-2">
            <label v-for="profile in profiles" :key="profile.id" class="flex items-center p-1">
              <input 
                type="checkbox" 
                :value="profile.id" 
                v-model="form.profile_ids" 
                class="mr-2"
              />
              <span>{{ profile.name }}</span>
            </label>
          </div>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Schedule Pattern *</label>
          <select v-model="form.pattern" class="input w-full" required>
            <option value="">Choose pattern...</option>
            <option value="daily">Daily at same time</option>
            <option value="weekly">Weekly on same day</option>
            <option value="weekdays">Weekdays only</option>
          </select>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Start Date *</label>
            <input v-model="form.start_date" type="date" class="input w-full" required />
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Time *</label>
            <input v-model="form.time" type="time" class="input w-full" required />
          </div>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button type="button" @click="$emit('close')" class="btn btn-secondary">
            Cancel
          </button>
          <button type="submit" class="btn btn-primary">
            Schedule All Calls
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useProfileStore } from '@/stores/profiles'

const emit = defineEmits(['close', 'save'])

const form = ref({
  profile_ids: [],
  pattern: '',
  start_date: '',
  time: ''
})

// Use real profiles from store
const profileStore = useProfileStore()
const profiles = profileStore.profiles

function save() {
  emit('save', form.value)
}
</script>